import { render, staticRenderFns } from "./StockTransfer.vue?vue&type=template&id=5f79d4ac"
import script from "./StockTransfer.vue?vue&type=script&lang=js"
export * from "./StockTransfer.vue?vue&type=script&lang=js"
import style0 from "./StockTransfer.vue?vue&type=style&index=0&id=5f79d4ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports